import { useEffect } from "react";

export const useDocumentTitle = (title: string, suffix = " | SupportRent") => {
  useEffect(() => {
    document.title = title + suffix;
  }, [title, suffix]);
};
